import {apiConstants} from "./constants";
import * as api from "../../utils/api"
import {firebaseAuth} from "../../utils/constants"

export function login(email, password) {
  return {
    payload: api.login(email, password),
    type: apiConstants.login.base
  };
}

export function logout() {
  return {payload: api.logout(), type: apiConstants.logout.base};
}

// firebaseAuth().onAuthStateChanged(function(user) {
//   if (user) {
//     return {payload: {}, type: apiConstants.login.fulfilled};
//   } else {
//     return {payload: {}, type: apiConstants.logout.fulfilled};
//   }
// });


// WEBPACK FOOTER //
// ./src/redux/actions/user.js